import React, { useState, useEffect, useRef, useContext } from 'react'
import styles from './Contacto.module.css'
import Subtitle from '../Subtitle'
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from "../../store/actions/generalActions";
import * as GeneralRepository from "../../services/repositories/general-repository";
//Utiles
import * as Constantes from '../../utils/constantes'

const Contacto = ({ asegurado, contratante, state, setState }) => {
  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  const [stateDistritos, setStateDistritos] = useState({})

  const distritosEcommerce = state.distritosEcommerce
  const distritoRef = useRef()

  const handleChangeText = (e, campo, tipoContacto) => {
    let valor = e.target.value

    if (tipoContacto === 'asegurado') {
      setState((state) => {
        return {
          ...state,
          asegurado: {
            ...state.asegurado,
            contacto: {
              ...state.asegurado.contacto,
              [campo]: valor
            }
          },
          campoValidado: {
            ...state.campoValidado,
            [campo]: true
          },
          noBloqueo: campo === 'email' ? false : state.noBloqueo
        }
      })
    } else if (tipoContacto === 'contratante') {
      setState((state) => {
        return {
          ...state,
          contratante: {
            ...state.contratante,
            contacto: {
              ...state.contratante.contacto,
              [campo]: valor
            }
          },
          campoValidado: {
            ...state.campoValidado,
            [campo]: true
          },
          noBloqueo: campo === 'email' ? false : state.noBloqueo 
        }
      })
    }
  }

  const handleChangeNumber = (e, campo, tipoContacto) => {
    let valor = e.target.value.replace(/\D/g, '')
    if (tipoContacto === 'asegurado') {
      setState((state) => {
        return {
          ...state,
          asegurado: {
            ...state.asegurado,
            contacto: {
              ...state.asegurado.contacto,
              [campo]: parseInt(valor)
            }
          },
          campoValidado: {
            ...state.campoValidado,
            [campo]: true
          },
          noBloqueo: false
        }
      })
    } else if (tipoContacto === 'contratante') {
      setState((state) => {
        return {
          ...state,
          contratante: {
            ...state.contratante,
            contacto: {
              ...state.contratante.contacto,
              [campo]: parseInt(valor),
            }
          },
          campoValidado: {
            ...state.campoValidado,
            [campo]: true
          },
          noBloqueo: false
        }
      })
    }
  }

  const handleChangeDistrito = (event, tipoContacto) => {
    if (tipoContacto === 'asegurado') {
      setState((state) => {
        return {
          ...state,
          asegurado: {
            ...state.asegurado,
            contacto: {
              ...state.asegurado.contacto,
              departamento: null,
              provincia: null,
              distrito: null
            }
          },
          campoValidado: {
            ...state.campoValidado,
            distrito: true
          }
        }
      })
    } else if (tipoContacto === 'contratante') {
      setState((state) => {
        return {
          ...state,
          contratante: {
            ...state.contratante,
            contacto: {
              ...state.contratante.contacto,
              departamento: null,
              provincia: null,
              distrito: null
            }
          },
          campoValidado: {
            ...state.campoValidado,
            distrito: true
          }
        }
      })
    }

    if (event.target.value.length > 2) {
      let distritosFiltered = distritosEcommerce.filter(
        (distritoEcommerce) =>
          distritoEcommerce.district
            .toUpperCase()
            .indexOf(event.target.value.toUpperCase()) === 0
      )

      setStateDistritos({
        ...stateDistritos,
        descripcion: event.target.value,
        verDistritos: true,
        distritosFilter: distritosFiltered,
      })
    } else {
      setStateDistritos({
        ...stateDistritos,
        descripcion: '',
        verDistritos: false,
        distritosFilter: [],
      })
    }
  }

  const handleDistritoListClick = (distrito, tipoContacto) => {
    setStateDistritos({
      ...stateDistritos,
      descripcion: distrito.district,
      distrito: distrito,
      verDistritos: false,
      errorSeleccionandoDistrito: false,
    })

    if (tipoContacto === 'asegurado') {
      setState((state) => {
        return {
          ...state,
          asegurado: {
            ...state.asegurado,
            contacto: {
              ...state.asegurado.contacto,
              departamento: {
                codigo: parseInt(distrito.departmentCode),
                descripcion: distrito.department
              },
              provincia: {
                codigo: parseInt(distrito.provinceCode),
                descripcion: distrito.province
              },
              distrito: {
                codigo: parseInt(distrito.districtCode),
                descripcion: distrito.district
              }
            }
          },
          campoValidado: {
            ...state.campoValidado,
            distrito: true
          }
        }
      })
    } else if (tipoContacto === 'contratante') {
      setState((state) => {
        return {
          ...state,
          contratante: {
            ...state.contratante,
            contacto: {
              ...state.contratante.contacto,
              departamento: {
                codigo: parseInt(distrito.departmentCode),
                descripcion: distrito.department
              },
              provincia: {
                codigo: parseInt(distrito.provinceCode),
                descripcion: distrito.province
              },
              distrito: {
                codigo: parseInt(distrito.districtCode),
                descripcion: distrito.district
              }
            }
          },
          campoValidado: {
            ...state.campoValidado,
            distrito: true
          }
        }
      })
    }

    distritoRef.current.value = (distrito.district + ', ' + distrito.province + ', ' + distrito.department)
  }

  function converti(cadena) {
    return (cadena && cadena.charAt(0).toUpperCase()) + (cadena && cadena.slice(1))
  }

  const obtenerListaDistritos = async () => {
    //generalDispatch(GeneralActions.updateEstadoCargando(true))
    const response = await GeneralRepository.obtenerListarDistritos(cotizacion)
    if(response.error === null) {
      setState((state) => {
        return {
          ...state,
          distritosEcommerce: response.listaDistritos,
          estaCargandoDistritos: false
        }
      })
    } else {
      generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
    }
    //generalDispatch(GeneralActions.updateEstadoCargando(false))
  }

  useEffect(() => {
    if (state.activaLlamado) {
      obtenerListaDistritos()
    }
  }, [state.activaLlamado])

  useEffect(() => {
    if (contratante && contratante.contacto === undefined) {
      distritoRef.current.value = null
    }
  }, [contratante && contratante.contacto])

  let objeto = null
  let objetoText = null
  if (asegurado) {
    objeto = asegurado
    objetoText = 'asegurado'
  } else if (contratante) {
    objeto = contratante
    objetoText = 'contratante'
  }
  //Modo lectura
  let Deshabilitar = (complete) => {
    complete = cotizacion.edicionInhabilitada
    if (complete === true) {
      return true
    } else {
      return false
    }
  }

  let contenido = null
  if (asegurado) {
    contenido =
    <div className={styles['areadatosprospecto']}>
      <Subtitle sname='Contacto' smostrar='false' />
      <div className={`${styles['grupodeform']} ${styles['top18']}`}>
        <div className={styles['area50']}>
          <label>Celular&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={!state.campoValidado.celular ? styles['logerror'] : null}
            type='text'
            value={objeto !== null && objeto !== undefined && objeto.contacto !== undefined ? objeto.contacto.celular || '' : ''}
            maxLength={9}
            onChange={(e) => handleChangeNumber(e, 'celular', objetoText)}
            style={objetoText === 'asegurado' ? { paddingLeft: "4%" } : null}
            disabled={Deshabilitar() !== true ? false : true}
          />
          {!state.campoValidado.celular ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_NUM_CELULAR}
            </span>
          ) : null}
        </div>
        <div className={styles['area75']}>
          <label>Correo Electrónico&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={!state.campoValidado['email'] ? styles['logerror'] : null}
            type='text'
            value={objeto !== null && objeto !== undefined && objeto.contacto !== undefined ? objeto.contacto.email || '' : ''}
            maxLength={60}
            onChange={(e) => handleChangeText(e, 'email', objetoText)}
            disabled={Deshabilitar() !== true ? false : true}
          />
          {!state.campoValidado['email'] ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_EMAIL}
            </span>
          ) : null}
          {state.campoValidado['emailRepetido'] !== undefined && !state.campoValidado['emailRepetido'] ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_EMAIL_REPETIDO}
            </span>
          ) : null}
        </div>
      </div>
      <div className={`${styles['grupodeform']} ${styles['top18']}`}>
        <div className={styles['area50']}>
          <label>Distrito&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={state.estaCargandoDistritos ? styles['loading']
              : !state.campoValidado.distrito
                ? styles['logerror']
                : null
            }
            type='text'
            defaultValue={
              objeto !== null && objeto !== undefined && objeto.contacto !== undefined && objeto.contacto.distrito ?
                converti(objeto.contacto.distrito.descripcion !== null && objeto.contacto.distrito.descripcion !== undefined ?
                  objeto.contacto.distrito.descripcion.toLowerCase() : '') + ', ' +
                converti(objeto.contacto.provincia.descripcion !== null && objeto.contacto.provincia.descripcion !== undefined ?
                  objeto.contacto.provincia.descripcion.toLowerCase() : '') + ', ' +
                converti(objeto.contacto.departamento.descripcion !== null && objeto.contacto.departamento.descripcion !== undefined ?
                  objeto.contacto.departamento.descripcion.toLowerCase() : '')
                : ''
            }
            onChange={(e) => handleChangeDistrito(e, objetoText)}
            ref={distritoRef}
            disabled={Deshabilitar() !== true ? state.estaCargandoDistritos : true} 
          />
          <div id='myInputautocomplete-list' className={styles['autocomplete-items2']}>
            {stateDistritos.verDistritos
              ? stateDistritos.distritosFilter.map((distrito) => (
                <div
                  key={distrito.ubigeo}
                  onClick={(event) => handleDistritoListClick(distrito, objetoText)}
                >
                  <strong>
                    {distrito.district.substring(
                      0,
                      stateDistritos.descripcion.length
                    )}
                  </strong>
                  {`${distrito.district.substring(
                    stateDistritos.descripcion.length,
                    distrito.district.length
                  )}, ${distrito.province}, ${distrito.department}`}
                </div>
              ))
              : null}
          </div>
          {!state.campoValidado.distrito && (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_DISTRITO}
            </span>
          )}
        </div>
        <div className={styles['area75']}>
          <label>Dirección&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={!state.campoValidado.direccion ? styles['logerror'] : null}
            type='text'
            value={objeto !== null && objeto !== undefined && objeto.contacto !== undefined ? objeto.contacto.direccion || '' : ''}
            onChange={(e) => handleChangeText(e, 'direccion', objetoText)}
            style={{ textTransform: "capitalize" }}
            disabled={Deshabilitar() !== true ? false : true}
            maxLength={100}
          />
          {!state.campoValidado.direccion ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_DIRECCION}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  } else if (contratante) {
    contenido = 
    <div className={styles['area-prospecto-card2']}>
      <Subtitle sname='Contacto' smostrar='false' />
      <div className={`${styles['grupo-de-form2']} ${styles['top18']}`}>
        <div className={styles['area-50']}>
          <label>Celular&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={!state.campoValidado.celular ? styles['logerror'] : null}
            type='text'
            value={objeto !== null && objeto !== undefined && objeto.contacto !== undefined ? objeto.contacto.celular || '' : ''}
            maxLength={9}
            onChange={(e) => handleChangeNumber(e, 'celular', objetoText)}
            style={objetoText === 'asegurado' ? { paddingLeft: "4%" } : null}
            disabled={Deshabilitar() !== true ? false : true}
          />
          {!state.campoValidado.celular ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_NUM_CELULAR}
            </span>
          ) : null}
        </div>
        <div>
          <label>Correo Electrónico&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={!state.campoValidado['email'] ? styles['logerror'] : null}
            type='text'
            value={objeto !== null && objeto !== undefined && objeto.contacto !== undefined ? objeto.contacto.email || '' : ''}
            maxLength={60}
            onChange={(e) => handleChangeText(e, 'email', objetoText)}
            disabled={Deshabilitar() !== true ? false : true}
          />
          {!state.campoValidado['email'] ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_EMAIL}
            </span>
          ) : null}
          {state.campoValidado['emailRepetido'] !== undefined && !state.campoValidado['emailRepetido'] ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_EMAIL_REPETIDO}
            </span>
          ) : null}
        </div>
        <div>
          <label>Distrito&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={state.estaCargandoDistritos ? styles['loading']
              : !state.campoValidado.distrito
                ? styles['logerror']
                : null
            }
            type='text'
            defaultValue={
              objeto !== null && objeto !== undefined && objeto.contacto !== undefined && objeto.contacto.distrito ?
                converti(objeto.contacto.distrito.descripcion !== null && objeto.contacto.distrito.descripcion !== undefined ?
                  objeto.contacto.distrito.descripcion.toLowerCase() : '') + ', ' +
                converti(objeto.contacto.provincia.descripcion !== null && objeto.contacto.provincia.descripcion !== undefined ?
                  objeto.contacto.provincia.descripcion.toLowerCase() : '') + ', ' +
                converti(objeto.contacto.departamento.descripcion !== null && objeto.contacto.departamento.descripcion !== undefined ?
                  objeto.contacto.departamento.descripcion.toLowerCase() : '')
                : ''
            }
            onChange={(e) => handleChangeDistrito(e, objetoText)}
            ref={distritoRef}
            disabled={Deshabilitar() !== true ? state.estaCargandoDistritos : true} />

          <div id='myInputautocomplete-list' className={styles['autocomplete-items']}>
            {stateDistritos.verDistritos
              ? stateDistritos.distritosFilter.map((distrito) => (
                <div
                  key={distrito.ubigeo}
                  onClick={(event) => handleDistritoListClick(distrito, objetoText)}
                >
                  <strong>
                    {distrito.district.substring(
                      0,
                      stateDistritos.descripcion.length
                    )}
                  </strong>
                  {`${distrito.district.substring(
                    stateDistritos.descripcion.length,
                    distrito.district.length
                  )}, ${distrito.province}, ${distrito.department}`}
                </div>
              ))
              : null}
          </div>
          {!state.campoValidado.distrito && (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_DISTRITO}
            </span>
          )}
        </div>
        <div>
          <label>Dirección&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            className={!state.campoValidado.direccion ? styles['logerror'] : null}
            type='text'
            value={objeto !== null && objeto !== undefined && objeto.contacto !== undefined ? objeto.contacto.direccion || '' : ''}
            onChange={(e) => handleChangeText(e, 'direccion', objetoText)}
            style={{ textTransform: "capitalize" }}
            disabled={Deshabilitar() !== true ? false : true}
            maxLength={100}
          />
          {!state.campoValidado.direccion ? (
            <span className={styles['span-error']}>
              {Constantes.MENSAJE_VALIDACION_DIRECCION}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  }

  return contenido
}

export default Contacto
